// src/containers/providers/Providers.tsx
import React, { PropsWithChildren } from 'react';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import { theme } from 'utils';
import { LogOutContextProvider } from '../../context';
import { AuthProvider } from '../../auth/AuthContext';

export const Providers = ({ children }: PropsWithChildren<unknown>) => {
	return (
		<AuthProvider>
			<LogOutContextProvider>
				<StyledEngineProvider injectFirst>
					<ThemeProvider theme={theme}>{children}</ThemeProvider>
				</StyledEngineProvider>
			</LogOutContextProvider>
		</AuthProvider>
	);
};
